module.exports = __webpack_public_path__ + "img/time_square.f941840e.svg";